module.exports = __webpack_public_path__ + "static/media/login-bg.28a0995c.jpg";